import { LocalPhone } from '@mui/icons-material'
import { Button } from '@mui/material'
import { Link } from 'react-router-dom'

const PHONE_NUMBER = '+49 896 2827670'

/**
 * A button that navigates to the help page when clicked.
 * @category Shared
 */
export function PhoneButton(): JSX.Element {
  return (
    <Button
      aria-label={'phone_number'}
      component={Link}
      to={`tel:${PHONE_NUMBER}`}
      color='inherit'
      variant='text'
      startIcon={<LocalPhone />}
    >
      {PHONE_NUMBER}
    </Button>
  )
}
